var skrollr = require("skrollr/dist/skrollr.min");

jQuery(function ($) {
  var currentElementPosition;

  skrollr.init();
  $("html").css("overflow", "auto");
  $("body").css("height", "auto");

  jQuery(window).on("scroll", function () {
    var count = 0;
    jQuery("section.work-info .container .row").removeClass("active");
    jQuery("section.work-info .container .row.align-center").each(function (
      event
    ) {
      count++;
      currentElementPosition = jQuery(this)
        .children(".invisible-dot")
        .offset().top;
      if (jQuery(".skrollr-body").offset().top > currentElementPosition) {
        jQuery("section.work-info .container .row.align-center").removeClass(
          "active"
        );
        jQuery("section.work-info").addClass("line-active");
        jQuery(this).addClass("active");
        jQuery(".skrollr-body.dot").removeClass("block1 block2 block3 block4");
        jQuery(".skrollr-body.dot").addClass("block" + count);
      } else {
        jQuery(".skrollr-body.dot").removeClass("block" + count);
      }
    });
  });

  jQuery(document).on("click", ".single-accordion", function (event) {
    event.preventDefault();
    let $this = $(this);

    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $this.children("p").slideUp(350);
    } else {
      jQuery(".single-accordion").removeClass("active");
      jQuery(".single-accordion").find("p").slideUp(350);
      $this.addClass("active");
      $this.children("p").slideDown(350);
    }
  });
  jQuery(document).ready(SkollrInit);
  jQuery(window).resize(SkollrInit);
});

function SkollrInit() {
  let SkollrStartPosition = jQuery("section.work-info").offset().top;
  let SkollrEndPosition =
    jQuery(".skollrstop").offset().top +
    jQuery("section.banner_header_section").offset().top -
    jQuery(".header-wrapper").height();
  let Difference = SkollrEndPosition - SkollrStartPosition;
  jQuery(".work-info .skrollr-body").attr(
    "data-" + SkollrStartPosition,
    "transform: translate(0px,0px);"
  );
  jQuery(".work-info .skrollr-body").attr(
    "data-" + SkollrEndPosition,
    "transform: translate(0px," + Difference + "px);"
  );
}



// WEBPACK FOOTER //
// ./scripts/how-it-works/script.js